<template>
  <div class="select">
    <span @click="visible = true">
      <Iconfont name="iconshaixuan" className="icon"></Iconfont>
    </span>
    <Popup v-model="visible" position="bottom">
      <Picker show-toolbar :columns="types" @cancel="visible = false" @confirm="onChange" />
    </Popup>
  </div>
</template>

<script>
import { Picker, Popup } from 'vant';
import Iconfont from '@/components/icon.vue';
export default {
  props: ['value'],
  components: { Picker, Popup, Iconfont },
  data() {
    return {
      visible: false,
      types: [
        this.$t('meeting.user.header.all'),
        this.$t('meeting.user.header.invite'),
        this.$t('meeting.user.header.book'),
      ],
    };
  },
  methods: {
    onChange(value) {
      let newValue = this.types.indexOf(value);
      this.$emit('update:value', newValue);
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.icon {
  font-size: 36px;
  margin-left: 20px;
}
</style>
